<div class="task-history-container">
  <h3 class="history-title">{{ 'task.taskHistory' | translate }}</h3>

  <!-- Empty State -->
  @if (!previousActions || previousActions.length === 0) {
    <div class="empty-state">
      <i class="bi bi-inbox"></i>
      <p>{{ 'task.noHistory' | translate }}</p>
    </div>
  }

  <!-- History Items -->
  @if (previousActions && previousActions.length > 0) {
    <div class="history-items">
      @for (action of previousActions; track $index; let i = $index) {
        <div class="history-item">
          <!-- Summary Row -->
          <div class="history-row" (click)="toggleExpand(i, action.taskId)" [class.expanded]="isExpanded(i)">
            <div class="expand-btn">
              <i [class]="isExpanded(i) ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
            </div>
            <div class="history-info">
              <span class="action-label">{{ 'actions.' + getActionLabel(action.logicalId) | translate }}</span>
              <span class="timestamp">{{ action.created | date: 'short' }}</span>
              <span class="changed-by">{{ 'common.by' | translate }}: {{ action.userName }}</span>
            </div>
          </div>

          <!-- Expanded Content -->
          @if (isExpanded(i)) {
            <div class="history-expanded">
              <div class="expanded-content">
                <!-- Error messages for form load -->
                @if (formLoadErrors.length > 0) {
                  <div class="alert alert-warning">
                    @for (err of formLoadErrors; track $index) {
                      <div>{{ err }}</div>
                    }
                  </div>
                }

                <!-- Read-only form -->
                <fb-bs-generic-formly-form
                  [formDefinition]="expandedFormDefinition"
                  [formData]="expandedFormModel"
                  [viewMode]="true">
                </fb-bs-generic-formly-form>

                @if (!isLoadingForm && expandedFormDefinition) {
                  <h4 class="data-title">{{ 'common.formData' | translate }}</h4>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
